module.exports = __webpack_public_path__ + "img/close.b840e171.svg";